<template>
  <div class="pro-info">
    <span class="title">昨日数据</span>
    <div class="pro-all">
      <div class="pro-item" v-for="(item, index) in proDataList" :key="'pro' + index">
        <div class="name">
          <span class="pro-name">{{item.name}}</span>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{item.tip}}</span>
            </template>
            <img src="@/assets/images/icon-question.png" alt="">
          </a-tooltip>
        </div>
        <div class="value">{{(index == 2 || index == 5 ) ? (item.value ? item.value * 100 : 0).toFixed(2) + '%' : (item.value ? item.value : 0)}}</div>
        <div class="pre">
          <span>较昨日</span>
          <span class="pre-value" :class="item.pre > 0 ? 'high' : item.pre < 0 ? 'low' : ''">{{item.pre ? (Math.abs(item.pre)*100).toFixed(2) + '%' : '0.00%'}}</span>
          <img v-if="item.pre" :src="item.pre > 0 ? require('@/assets/images/grow-up.png') : require('@/assets/images/grow-down.png')" alt="">
          <span v-else>--</span>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'ant-design-vue'
import  _  from 'lodash'
import moment from 'moment'
export default {
  components: {
    [Tooltip.name]: Tooltip
  },
  created() {
    this.getAllCommodityInfo()
  },
  data () {
    return {
      proDataList: [
        {name:'SKU在售商品数', tip:'统计周期内，店铺商品为在售状态的商品数量。'},
        {name:'SKU动销商品数', tip:'统计周期内，有成交的商品的品种数。成交商品为在统计时间段内完成支付且未取消的订单的商品'},
        {name:'SKU商品动销率', tip:'统计周期内，动销商品数/在售商品数，即有成交的商品的品种数占在售商品数的比例'},
        {name:'SPU在售商品数', tip:'统计周期内，店铺商品为在售状态的商品数量。'},
        {name:'SPU动销商品数', tip:'统计周期内，有成交的商品的品种数。成交商品为在统计时间段内完成支付且未取消的订单的商品'},
        {name:'SPU商品动销率', tip:'统计周期内，动销商品数/在售商品数，即有成交的商品的品种数占在售商品数的比例'}
      ]
    }
  },
  methods: {
    async getAllCommodityInfo() {
      let paramsSku = {
        isTop10:1, // 排名前10的商品
        commodityType:2,  // SKU 维度
        cycleType:1, // 按日查看
        occurtime:moment(new Date()).subtract(1,'days').format('YYYYMMDD')
      }
      let skuRes = await this.$store.dispatch('popHome/getCommodityInfo', paramsSku)
      this.proDataList[0].value = Number(_.get(skuRes, ['data', 'sku_onshelf'], 0))
      this.proDataList[0].pre = Number(_.get(skuRes, ['data', 'sku_onshelf_chg'], 0))
      this.proDataList[1].value = Number(_.get(skuRes, ['data', 'sku_movable_num'], 0))
      this.proDataList[1].pre = Number(_.get(skuRes, ['data', 'sku_movable_num_chg'], 0))
      this.proDataList[2].value = Number(_.get(skuRes, ['data', 'sku_movable_rate'], 0))
      this.proDataList[2].pre = Number(_.get(skuRes, ['data', 'sku_movable_rate_chg'], 0))
      let paramsSpu = {
        isTop10:1, // 排名前10的商品
        commodityType:1,  // SPU 维度
        cycleType:1, // 按日查看
        occurtime:moment(new Date()).subtract(1,'days').format('YYYYMMDD')
      }
      let spuRes = await this.$store.dispatch('popHome/getCommodityInfo', paramsSpu)
      this.proDataList[3].value = Number(_.get(spuRes, ['data', 'spu_onshelf'], 0))
      this.proDataList[3].pre = Number(_.get(spuRes, ['data', 'spu_onshelf_chg'], 0))
      this.proDataList[4].value = Number(_.get(spuRes, ['data', 'spu_movable_num'], 0))
      this.proDataList[4].pre = Number(_.get(spuRes, ['data', 'spu_movable_num_chg'], 0))
      this.proDataList[5].value = Number(_.get(spuRes, ['data', 'spu_movable_rate'], 0))
      this.proDataList[5].pre = Number(_.get(spuRes, ['data', 'spu_movable_rate_chg'], 0))
      // 刷新
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.pro-info {
  display: flex;
  flex-direction: column;
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: 20px;
  }
  .pro-all {
    display: flex;
    flex-wrap: wrap;
    .pro-item {
      display: flex;
      flex-direction: column;
      width: 25%;
      font-family: MicrosoftYaHei;
      letter-spacing: 0;
      margin-bottom: 20px;
      .name {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666666;
        img {
          width: 14px;
          height: 14px;
          flex-shrink: 0;
          margin-left: 4px;
        }
      }
      .value {
        font-size: 20px;
        color: #333333;
        line-height: 17px;
        margin-top: 15px;
      }
      .pre {
        display: flex;
        align-items: center;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: 10px;
        .pre-value {
          color: #666666;
          margin-left: 10px;
          margin-right: 5px;
        }
        .high {
          color: #00C414;
        }
        .low {
          color: #FF3A00;
        }
        img {
          width: 6px;
          height: 12px;
        }
      }
    }
  }
}
</style>
